import { useFeatureIsOn } from "@growthbook/growthbook-react";

import { FEATURE_FLAGS } from "@/constants";

export const useFeatureFlag = (featureName: string) => {
  const hasGrowthbookLoaded = useFeatureIsOn(FEATURE_FLAGS.GROWTHBOOK_LOADED);
  const isLoading = !hasGrowthbookLoaded; // only resolve loading when growthbook loaded feature flag gets resolved.
  const hasFeatureFlag = useFeatureIsOn(featureName);

  return {
    hasFeatureFlag,
    isLoading,
  };
};
